import {NgModule} from '@angular/core';
import {JdDrawerModule} from './drawer/drawer.module';
import {JdDyFormModule} from './dy-form/dy-form.module';
// import {JdEChartModule} from './e-chart/echart.module';
import {JdFormModule} from './form/form.module';
import {JdGridModule} from './grid/jd-grid.module';
import {JdInputModule} from './input/jd-input.module';
import {JdMessageModule} from './message/message.module';
import {JdSelectModule} from './select/jd-select.module';
import {JdSelectTableModule} from './table-select/jd-select.module';
import {JdToolTipModule} from './tool-tip/tool-tip.module';
import {JdTransferModule} from './transfer/transfer.module';
import {JdXlsxModule} from './xlsx/xlsx.module';
import {JdI18nModule} from "./i18n/nz-i18n.module";
// import {JdTimePickerModule} from "./time-picker/nz-time-picker.module";
// import {JdDatePickerModule} from "./date-picker/date-picker.module";
// import {JdXlsxModule} from './xlsx/xlsx.module';

const EXPORT_MODLUE = [
  JdDrawerModule,
  JdDyFormModule,
  // JdEChartModule,
  JdFormModule,
  JdGridModule,
  JdInputModule,
  JdMessageModule,
  JdSelectModule,
  JdSelectTableModule,
  JdToolTipModule,
  JdTransferModule,
  JdXlsxModule,
  // JdTimePickerModule,
  // JdDatePickerModule,
  JdI18nModule
];

@NgModule({
  imports: [...EXPORT_MODLUE],
  declarations: [],
  exports: [...EXPORT_MODLUE]
})
export class JdClModule {
}
